import gql from 'graphql-tag';

const ADDRESS_FRAGMENT = gql`
	fragment address on Address {
		id
		region
		city
		street
		postcode
	}
`;

export const CREATE_ADDRESS = gql`
	mutation createAddressMutation($input: CreateAddressInput!) {
		createAddress(input: $input) {
			id
			region
			city
			street
			postcode
		}
  }
`;

export const MODIFY_ADDRESS = gql`
	mutation modifyAddressMutation($input: ModifyAddressInput!) {
		modifyAddress(input: $input) {
			address {
				...address
			}
		}
	}
	${ADDRESS_FRAGMENT}
`;
